import { createSelector } from 'reselect';
import storage from '@xto10x/storage/lib';
import {
  FirebaseKeys,
  StorageKey,
  UserRole,
  AppConfigStorageKeys
} from 'utils/constants';
import actions from './actions';

const isFeatureEnable = (
  config,
  feature,
  userRole,
  orgId = storage.getDataFromLocal(StorageKey.ORG_INFO)?.org_reference_id
) => {
  const feature_config_object = config[feature];
  return (
    feature_config_object != null &&
    feature_config_object.enable &&
    (feature_config_object.orgs == null ||
      feature_config_object.orgs.length === 0 ||
      feature_config_object.orgs.includes(orgId)) &&
    (feature_config_object.excludedOrgs == null ||
      feature_config_object.excludedOrgs.length === 0 ||
      !feature_config_object.excludedOrgs.includes(orgId)) &&
    (feature_config_object.access_role == null ||
      feature_config_object.access_role === UserRole.USER ||
      feature_config_object.access_role === userRole)
  );
};

const getFeatureWiseConfig = (featureConfig, userRoles) => {
  const config = {};
  Object.values(FirebaseKeys)
    .filter(
      key =>
        [
          FirebaseKeys.api_error_code_mapping,
          FirebaseKeys.feature_config
        ].indexOf(key) === -1
    )
    .forEach(key => {
      if (typeof key === 'string')
        config[key] = isFeatureEnable(featureConfig, key, userRoles?.okr);
    });
  return config;
};

const createFeatureFlagConfig = featureConfig => {
  const config = {};
  if (!featureConfig) return config;
  Object.keys(featureConfig).forEach(key => {
    if (typeof key === 'string')
      config[key] = isFeatureEnable(featureConfig, key);
  });
  return config;
};

const initialState = {
  featureConfig: {},
  featureFlagConfig: {},
  peopleFeatureConfig: {},
  cuesFeatureConfig: {},
  cuesFeatureFlagConfig: {}
};

export const getFeatureConfig = createSelector(
  state => state.appConfigReducer.featureConfig,
  featureConfig => featureConfig
);

export const getFeatureFlagConfig = createSelector(
  state => state.appConfigReducer.featureFlagConfig,
  featureFlagConfig => featureFlagConfig
);

export const getPeopleFeatureConfig = createSelector(
  state => state.appConfigReducer.peopleFeatureConfig,
  peopleFeatureConfig => peopleFeatureConfig
);

export const getFeaturePanelConfig = createSelector(
  state => state.appConfigReducer.featurePanelConfig,
  featurePanelConfig => featurePanelConfig
);

export const getCuesFeatureConfig = createSelector(
  state => state.appConfigReducer.cuesFeatureConfig,
  cuesFeatureConfig => cuesFeatureConfig
);

export const getCuesFeatureFlagConfig = createSelector(
  state => state.appConfigReducer.cuesFeatureFlagConfig,
  cuesFeatureFlagConfig => cuesFeatureFlagConfig
);

const appConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_APP_CONFIG: {
      const commonFeatureConfig =
        action.payload?.[AppConfigStorageKeys.goals_feature_config];
      const peopleFeatureConfig =
        action.payload?.[AppConfigStorageKeys.people_feature_config];
      const cuesFeatureConfig =
        action.payload?.[AppConfigStorageKeys.cues_feature_config];
      const featurePanelConfig =
        action.payload?.[AppConfigStorageKeys.whats_new_config];
      const { userRoles } = action.payload;
      return {
        ...state,
        featureConfig: commonFeatureConfig,
        featureFlagConfig: getFeatureWiseConfig(commonFeatureConfig, userRoles),
        peopleFeatureConfig,
        cuesFeatureConfig,
        cuesFeatureFlagConfig: createFeatureFlagConfig(cuesFeatureConfig),
        featurePanelConfig
      };
    }
    case actions.REFRESH_FEATURE_FLAGS:
      if (JSON.stringify(state.featureConfig) !== '{}')
        return {
          ...state,
          featureFlagConfig: getFeatureWiseConfig(state.featureConfig)
        };
      return state;
    default:
      return state;
  }
};

export default appConfigReducer;
